<!--
 * @Author: zhaoliang
 * @Date: 2024-05-29 14:44:53
 * @LastEditTime: 2025-10-10 17:23:18
 * @LastEditors: zhaoliang
 * @Description:
 * @FilePath: /visa-canada/src/views/Membership/component/Notify/index.vue
 *
-->
<template>
  <div class="notify-containner">
    <h2 class="global-title">{{ $t('mbs-select-notify') }}</h2>
    <div class="notify-content">
      <div class="notify-tips">{{ $t('mbs-select-notify-tips') }}</div>
      <div class="notify-lists">
        <div
          class="notify-items"
          :class="{ 'is-unread': item.read === '0' }"
          v-for="item in msgList"
          :key="item.id"
          @click="goDetail(item)"
        >
          <img class="icons-noyify" src="~img/icon-notify.svg" alt="" />
          <div class="msg-box">
            <p class="title">{{ item.title }}</p>
            <p class="content">{{ item.description }}</p>
            <p></p>
          </div>
          <img class="icons-go" src="~img/icon-arrow-right.svg" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  export default {
    name: 'Notify',
    components: {},
    data() {
      return {
        msgList: [],
      };
    },
    computed: {
      ...mapState(['userInfo', 'hasUnresdMsg']),
    },
    mounted() {
      this.getNotificationList();
    },
    methods: {
      goDetail(item) {
        console.log('message', item);
        this.updateNotificationStatus(item);
        this.$router.push({
          path: 'tripsDetail',
          query: {
            orderNo: item.orderNo,
          },
        });
      },
      updateUnreadStatus() {
        // 没有单独接口,只需要拿到unreadCount字段,pageSize设置10即可
        this.$http.common
          .getNotificationList({
            lang: this.$i18n.locale,
            userId: this.userInfo.userId,
            sessionId: this.userInfo.sessionId,
            device: 'web',
            pageNum: 1,
            pageSize: 10,
          })
          .then(
            res => {
              if (res?.state === '11') {
                this.$store.commit('setState', {
                  state: 'hasUnresdMsg',
                  values: res?.payload?.unreadCount > 0 || false,
                });
              } else {
                console.error(res?.note);
              }
            },
            err => {
              console.error(err);
            },
          );
      },
      getNotificationList() {
        this.$http.common
          .getNotificationList({
            lang: this.$i18n.locale,
            userId: this.userInfo.userId,
            sessionId: this.userInfo.sessionId,
            device: 'web',
            pageNum: 1,
            pageSize: 999,
          })
          .then(
            res => {
              if (res?.state === '11') {
                this.msgList = res?.payload?.result || [];
                this.$store.commit('setState', {
                  state: 'hasUnresdMsg',
                  values: res?.payload?.unreadCount > 0 || false,
                });
              } else {
                console.error(res?.note);
              }
            },
            err => {
              console.error(err);
            },
          );
      },
      updateNotificationStatus(item) {
        this.$http.common
          .updateNotificationStatus({
            lang: this.$i18n.locale,
            userId: this.userInfo.userId,
            sessionId: this.userInfo.sessionId,
            id: item.id,
          })
          .then(
            res => {
              if (res?.state === '11') {
                this.updateUnreadStatus();
              } else {
                console.error(res?.note);
              }
            },
            err => {
              console.error(err);
            },
          );
      },
    },
  };
</script>
<style lang="scss" scoped>
  .notify-containner {
    @include global-title();
    .global-title {
      margin-bottom: 32px;
    }

    .notify-content {
      .notify-tips {
        @include font(18px, 400);
        color: #667077;
        padding-bottom: 30px;
        border-bottom: 1px solid #9eacb5;
      }

      .notify-lists {
        padding: 20px 0;

        .notify-items {
          width: 100%;
          display: flex;
          align-items: center;
          padding: 20px 0;
          border-bottom: 1px solid #9eacb5;
          cursor: pointer;
          box-sizing: border-box;
          position: relative;

          &.is-unread::before {
            content: ' ';
            position: absolute;
            width: 10px;
            height: 10px;
            background-color: #e02d3c;
            border-radius: 50%;
            left: 40px;
            top: 20px;
          }

          .icons-noyify {
            align-self: flex-start;
            margin-right: 20px;
            width: 40px;
            height: 40px;
          }
          .msg-box {
            flex: 1;
            .title {
              @include font(24px, 600);
              margin-bottom: 10px;
            }

            .content {
              @include font(20px, 400);
            }
          }
          .icons-go {
            width: 32px;
            height: 32px;
            margin-left: 20px;
          }
        }
      }
    }
  }

  @media screen and (max-width: 1024px) {
    .notify-containner {
      .global-title {
        @include font(18px, 600);
        line-height: 40px;
        margin-bottom: 12px;
        padding: 0;
      }

      .notify-content {
        .notify-tips {
          @include font(12px, 400);
          padding-top: 15px;
          padding-bottom: 15px;
        }

        .notify-lists {
          padding: 10px 0;

          .notify-items {
            padding: 10px 0;

            &.is-unread::before {
              content: ' ';
              position: absolute;
              width: 6px;
              height: 6px;
              background-color: #e02d3c;
              border-radius: 50%;
              left: 25px;
              top: 10px;
            }

            .icons-noyify {
              margin-right: 10px;
              width: 25px;
              height: 25px;
            }
            .msg-box {
              .title {
                @include font(16px, 600);
                margin-bottom: 5px;
              }

              .content {
                @include font(14px, 400);
                line-height: 16px;
              }
            }
            .icons-go {
              width: 20px;
              height: 20px;
              margin-left: 10px;
            }
          }
        }
      }
    }
  }
</style>
